import ConnectorsPage from 'routes/Connectors'
import { CONNECTORS_API, CONNECTORS_REVALIDATE_TIME } from 'routes/constants'

export default function WebsiteConnectors({ connectors }) {
  return <ConnectorsPage connectors={connectors} />
}

export async function getStaticProps() {
  // Fetch data from external API
  const res = await fetch(`${CONNECTORS_API}`)
  const connectors = (await res.json()).map((c) => ({
    key: c.key,
    name: c.name,
    iconSrc: c.logoUri,
    status: c?.status ?? 'planned',
    categories: c?.categories ?? [],
  }))

  // Pass data to the page via props
  return {
    props: { connectors },
    revalidate: CONNECTORS_REVALIDATE_TIME, // In seconds
  }
}
